import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVRadioBtn } from "../../../shared/JVRadioBtn";
import { ITrainingRatingDetails } from "./AllRating";
import { ILogin } from "../../../models/Login";

interface IProps {
    open: boolean,
    singleData: ITrainingRatingDetails,
    hideDialog: () => void,
    reloadTable: () => void,
    toast: any,
}

interface IFromData {
    approve_Status?: string,
    comment?: string,
}

const schema = yup.object({
    approve_Status: yup.string().required("Status is required*"),
    comment: yup.string().nullable(),
});

export const ApproveRejectRating = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [shwReject, setShwReject] = useState<boolean>(false);
    const [disableAll, setDisableAll] = useState<boolean>(false);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IFromData>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onHide = () => {
        reset({ approve_Status: "", comment: "" });
        setShwReject(false);
        setLoading(false);
        props.reloadTable();
        props.hideDialog();
    }

    const onSubmit = async (data: IFromData) => {
        if (data.approve_Status === "Reject" && (data.comment === null || data.comment?.trim() === "")) {
            props.toast.current.show({ severity: 'error', detail: "Please give reason for Rejection", life: 3000 });
        } else {
            setLoading(true);
            const bodyData = {
                Rating_ID: props.singleData.rating_ID,
                approve_Status: data.approve_Status === "Accept" ? true : false,
                comment: data.comment
            };
            const method = "PUT";
            const message = "Updated Successfully";
            const url = "updateApproveStatusOfRating";

            const response = await Fetch(("CarnivalTraining/" + url), method, bodyData, null, props.toast);

            if (response) {
                setLoading(false);
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                onHide();
            } else setLoading(false);
        }
    }

    const header = () => {
        return <p></p>
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "approve_Status") {
                if (value.approve_Status != null && value.approve_Status === "Accept") {
                    setShwReject(false);
                } else if (value.approve_Status != null && value.approve_Status === "Reject") {
                    setShwReject(true);
                } else {
                    setShwReject(false);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, shwReject]);

    useEffect(() => {
        if (props.open && props.singleData.approve_Status !== null) {
            reset({
                approve_Status: props.singleData.approve_Status === true ? "Accept" : "Reject",
                comment: props.singleData.comment,
            });
            setShwReject(true);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '40vw' }} header="Add/Edit Rating Status" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVRadioBtn inline label="Status" data={[{"label": "Accept", "value": "Accept"}, {"label": "Reject", "value": "Reject"}]} column={3} control={control} name="approve_Status" />
                {shwReject && <JVInput column={1} required disabled={!shwReject} label="Reason For Rejection" control={control} name="comment" error={errors.comment?.message} />}
                {(props.singleData.approve_Status === null || (_roles.includes(1) || _roles.includes(26) || _roles.includes(11))) && <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading} disabled={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>}
            </form>
        </Dialog>
    );
}